import React, { useEffect, useRef, useState } from 'react';
import { preloadAssets } from '../../utils/AddressableManager';
import { PALEO_EARTH_FRAMES } from '../../utils/PaleoEarthAssets';
import { PALEO_ATLAS_URL } from '../../utils/PaleoAtlasConfig';

import './PlanetPreloader.css';


export const planetAssets = [
  // planet model
  { type: 'gltf', key: 'planetmodel', url: '/models/planet/planet_model.glb' },

  // planet textures
  { type: 'texture', key: 'mercury', url: '/textures/2k_mercury.jpg' },
  { type: 'texture', key: 'venus', url: '/textures/2k_venus.jpg' },
  // { type: 'texture', key: 'earth', url: '/textures/2k_earth.jpg' },
  // { type: 'texture', key: 'earth', url: '/textures/8k_earth.jpg' },
  { type: 'texture', key: 'earth', url: '/textures/earth_textures/map01a_paleomap_paleoatlas_000.jpg' },

  { type: 'texture', key: 'moon', url: '/textures/2k_moon.jpg' },
  { type: 'texture', key: 'mars', url: '/textures/2k_mars.jpg' },
  { type: 'texture', key: 'jupiter', url: '/textures/2k_jupiter.jpg' },
  { type: 'texture', key: 'saturn', url: '/textures/2k_saturn.jpg' },
  { type: 'texture', key: 'uranus', url: '/textures/2k_uranus.jpg' },
  { type: 'texture', key: 'neptune', url: '/textures/2k_neptune.jpg' },
  { type: 'texture', key: 'pluto', url: '/textures/2k_pluto.jpg' },
  { type: 'texture', key: 'sun', url: '/textures/2k_sun.jpg' },

  // kuiper belt textures
  { type: 'texture', key: '2002 aw197', url: '/textures/kuiperbelt/2k_2002aw197.jpg' },
  { type: 'texture', key: '2003 az84', url: '/textures/kuiperbelt/2k_2003az84.jpg' },
  { type: 'texture', key: '2002 ms4', url: '/textures/kuiperbelt/2k_2002ms4.jpg' },
  { type: 'texture', key: '2002 tc302', url: '/textures/kuiperbelt/2k_2002tc302.jpg' },
  { type: 'texture', key: '2002 tx300', url: '/textures/kuiperbelt/2k_2002tx300.jpg' },
  { type: 'texture', key: '2002 ux25', url: '/textures/kuiperbelt/2k_2002ux25.jpg' },
  { type: 'texture', key: 'chaos', url: '/textures/kuiperbelt/2k_chaos.jpg' },
  { type: 'texture', key: 'eris', url: '/textures/kuiperbelt/2k_eris.jpg' },
  { type: 'texture', key: 'gonggong', url: '/textures/kuiperbelt/2k_gonggong.jpg' },
  { type: 'texture', key: 'haumea', url: '/textures/kuiperbelt/2k_haumea.jpg' },
  { type: 'texture', key: 'ixion', url: '/textures/kuiperbelt/2k_ixion.jpg' },
  { type: 'texture', key: 'lempo', url: '/textures/kuiperbelt/2k_lempo.jpg' },
  { type: 'texture', key: 'makemake', url: '/textures/kuiperbelt/2k_makemake.jpg' },
  { type: 'texture', key: 'orcus', url: '/textures/kuiperbelt/2k_orcus.jpg' },
  { type: 'texture', key: 'quaoar', url: '/textures/kuiperbelt/2k_quaoar.jpg' },
  { type: 'texture', key: 'salacia', url: '/textures/kuiperbelt/2k_salacia.jpg' },
  { type: 'texture', key: 'sedna', url: '/textures/kuiperbelt/2k_sedna.png' },
  { type: 'texture', key: 'varda', url: '/textures/kuiperbelt/2k_varda.jpg' },
  { type: 'texture', key: 'varuna', url: '/textures/kuiperbelt/2k_varuna.jpg' },

  // ring textures
  { type: 'texture', key: 'saturn_rings_tex_1', url: '/textures/2k_saturn_rings_inner.png' },
  { type: 'texture', key: 'saturn_rings_tex_2', url: '/textures/2k_saturn_rings_main.png' },
  { type: 'texture', key: 'saturn_rings_tex_3', url: '/textures/2k_saturn_rings_outer.png' },

  { type: 'texture', key: 'jupiter_rings_tex_1', url: '/textures/2k_jupiter_rings_inner.png' },
  { type: 'texture', key: 'jupiter_rings_tex_2', url: '/textures/2k_jupiter_rings_main.png' },
  { type: 'texture', key: 'jupiter_rings_tex_3', url: '/textures/2k_jupiter_rings_outer.png' },

  { type: 'texture', key: 'uranus_rings_tex_1', url: '/textures/2k_uranus_rings_inner.png' },
  { type: 'texture', key: 'uranus_rings_tex_2', url: '/textures/2k_uranus_rings_main.png' },
  { type: 'texture', key: 'uranus_rings_tex_3', url: '/textures/2k_uranus_rings_outer.png' },

  { type: 'texture', key: 'neptune_rings_tex_1', url: '/textures/2k_neptune_rings_inner.png' },
  { type: 'texture', key: 'neptune_rings_tex_2', url: '/textures/2k_neptune_rings_main.png' },
  { type: 'texture', key: 'neptune_rings_tex_3', url: '/textures/2k_neptune_rings_outer.png' },

  // ring models
  { type: 'gltf', key: 'SaturnRingInner', url: '/models/rings/saturn/ring_inner.glb' },
  { type: 'gltf', key: 'SaturnRingMain', url: '/models/rings/saturn/ring_main.glb' },
  { type: 'gltf', key: 'SaturnRingOuter', url: '/models/rings/saturn/ring_outer.glb' },

  { type: 'gltf', key: 'UranusRingInner', url: '/models/rings/uranus/ring_inner.glb' },
  { type: 'gltf', key: 'UranusRingMain', url: '/models/rings/uranus/main_division.glb' },
  { type: 'gltf', key: 'UranusRingOuter', url: '/models/rings/uranus/outer_diffuse.glb' },

  { type: 'gltf', key: 'JupiterRingInner', url: '/models/rings/jupiter/ring_inner.glb' },
  { type: 'gltf', key: 'JupiterRingMain', url: '/models/rings/jupiter/ring_main.glb' },
  { type: 'gltf', key: 'JupiterRingOuter', url: '/models/rings/jupiter/ring_outer.glb' },
  
  { type: 'gltf', key: 'NeptuneRingInner', url: '/models/rings/neptune/ring_inner.glb' },
  { type: 'gltf', key: 'NeptuneRingMain', url: '/models/rings/neptune/ring_main.glb' },
  { type: 'gltf', key: 'NeptuneRingOuter', url: '/models/rings/neptune/ring_outer.glb' },

];

export const earthAssets = PALEO_EARTH_FRAMES.map((frame) => ({
  type: 'texture',
  key: frame.key,   // e.g. 'paleo_earth_93a' — unique per frame
  url: frame.url,
}));

export const missionAssets =[
  //Missions
  //Mecury
  { type: 'image', key: 'mariner10spacecraft', url: '/images/missions/mercury/mariner10_spacecraft.jpg' },
  { type: 'image', key: 'mariner10', url: '/images/missions/mercury/mariner10.jpg' },

  { type: 'image', key: 'messengerspacecraft', url: '/images/missions/mercury/messenger_spacecraft.jpg' },
  { type: 'image', key: 'messenger', url: '/images/missions/mercury/messenger.webp' },
  
  { type: 'image', key: 'bepicolombospacecraft', url: '/images/missions/mercury/bepicolombo_spacecraft.jpg' },
  { type: 'image', key: 'bepicolombo', url: '/images/missions/mercury/bepicolombo.jpg' },

  //Venus
  { type: 'image', key: 'mariner2spacecraft', url: '/images/missions/venus/mariner2_spacecraft.jpg' },

  { type: 'image', key: 'venera7spacecraft', url: '/images/missions/venus/venera7_spacecraft.jpg' },

  { type: 'image', key: 'venera13spacecraft', url: '/images/missions/venus/venera13_spacecraft.webp' },
  { type: 'image', key: 'venera13', url: '/images/missions/venus/venera13.jpg' },

  { type: 'image', key: 'pioneervenusspacecraft', url: '/images/missions/venus/pioneervenus_spacecraft.jpg' },
  { type: 'image', key: 'pioneervenus', url: '/images/missions/venus/pioneervenus.png' },
  
  { type: 'image', key: 'magellanspacecraft', url: '/images/missions/venus/magellan_spacecraft.jpg' },
  { type: 'image', key: 'magellan', url: '/images/missions/venus/magellan.jpeg' },

  { type: 'image', key: 'venusexpressspacecraft', url: '/images/missions/venus/venusexpress_spacecraft.jpg' },
  { type: 'image', key: 'venusexpress', url: '/images/missions/venus/venusexpress.jpg' },

  { type: 'image', key: 'akatsukispacecraft', url: '/images/missions/venus/akatsuki_spacecraft.jpg' },
  { type: 'image', key: 'akatsuki', url: '/images/missions/venus/akatsuki.webp' },

  //Mars
  { type: 'image', key: 'mariner4spacecraft', url: '/images/missions/mars/mariner4_spacecraft.jpg' },
  { type: 'image', key: 'mariner4', url: '/images/missions/mars/mariner4.jpg' },

  { type: 'image', key: 'vikingspacecraft', url: '/images/missions/mars/viking_spacecraft.jpg' },
  { type: 'image', key: 'viking', url: '/images/missions/mars/viking.jpg' },

  { type: 'image', key: 'sojournerspacecraft', url: '/images/missions/mars/sojourner_spacecraft.jpg' },
  { type: 'image', key: 'sojourner', url: '/images/missions/mars/sojourner.jpg' },

  { type: 'image', key: 'marsexpressspacecraft', url: '/images/missions/mars/marsexpress_spacecraft.jpg' },
  { type: 'image', key: 'marsexpress', url: '/images/missions/mars/marsexpress.jpg' },

  { type: 'image', key: 'spiritspacecraft', url: '/images/missions/mars/spirit_spacecraft.jpg' },
  { type: 'image', key: 'spirit', url: '/images/missions/mars/spirit.jpg' },

  { type: 'image', key: 'mavenspacecraft', url: '/images/missions/mars/maven_spacecraft.jpg' },
  { type: 'image', key: 'maven', url: '/images/missions/mars/maven.jpg' },

  { type: 'image', key: 'curiosityspacecraft', url: '/images/missions/mars/curiosity_spacecraft.jpg' },
  { type: 'image', key: 'curiosity', url: '/images/missions/mars/curiosity.jpg' },

  { type: 'image', key: 'insightspacecraft', url: '/images/missions/mars/insight_spacecraft.jpg' },
  { type: 'image', key: 'insight', url: '/images/missions/mars/insight.jpg' },

  { type: 'image', key: 'perseverancespacecraft', url: '/images/missions/mars/perseverance_spacecraft.jpg' },
  { type: 'image', key: 'perseverance', url: '/images/missions/mars/perseverance.webp' },

  { type: 'image', key: 'zhurongspacecraft', url: '/images/missions/mars/zhurong_spacecraft.jpeg' },
  { type: 'image', key: 'zhurong', url: '/images/missions/mars/zhurong.jpeg' },

  { type: 'image', key: 'hopespacecraft', url: '/images/missions/mars/hope_spacecraft.jpeg' },
  { type: 'image', key: 'hope', url: '/images/missions/mars/hope.jpeg' },

  { type: 'image', key: 'exomarsspacecraft', url: '/images/missions/mars/exomars_spacecraft.jpg' },
  { type: 'image', key: 'exomars', url: '/images/missions/mars/exomars.jpg' },

  // Jupiter
  { type: 'image', key: 'pioneer10spacecraft', url: '/images/missions/jupiter/pioneer10_spacecraft.jpg' },
  { type: 'image', key: 'pioneer10', url: '/images/missions/jupiter/pioneer10.png' },

  { type: 'image', key: 'voyager1spacecraft', url: '/images/missions/jupiter/voyager1_spacecraft.webp' },
  { type: 'image', key: 'voyager1_jupiter', url: '/images/missions/jupiter/voyager1.webp' },

  { type: 'image', key: 'galileospacecraft', url: '/images/missions/jupiter/galileo_spacecraft.png' },
  { type: 'image', key: 'galileo', url: '/images/missions/jupiter/galileo.webp' },

  { type: 'image', key: 'junospacecraft', url: '/images/missions/jupiter/juno_spacecraft.jpg' },
  { type: 'image', key: 'juno', url: '/images/missions/jupiter/juno.jpg' },

  { type: 'image', key: 'juicespacecraft', url: '/images/missions/jupiter/juice_spacecraft.png' },

  // Saturn
  { type: 'image', key: 'pioneer11spacecraft', url: '/images/missions/saturn/pioneer11_spacecraft.jpg' },
  { type: 'image', key: 'pioneer11', url: '/images/missions/saturn/pioneer11.jpeg' },

  { type: 'image', key: 'voyager1_saturn', url: '/images/missions/saturn/voyager1.webp' },

  { type: 'image', key: 'cassinihuygensspacecraft', url: '/images/missions/saturn/cassini-huygens_spacecraft.jpg' },
  { type: 'image', key: 'cassinihuygens', url: '/images/missions/saturn/cassini-huygens.jpg' },

  // Uranus
  { type: 'image', key: 'voyager2spacecraft', url: '/images/missions/uranus/voyager2_spacecraft.webp' },
  { type: 'image', key: 'voyager2_uranus', url: '/images/missions/uranus/voyager2.jpg' },

  // Neptune
  { type: 'image', key: 'voyager2_neptune', url: '/images/missions/neptune/voyager2.jpg' },

  // Moon
  { type: 'image', key: 'luna2spacecraft', url: '/images/missions/moon/luna2_spacecraft.jpg' },
  { type: 'image', key: 'luna2', url: '/images/missions/moon/luna2.webp' },

  { type: 'image', key: 'surveyorspacecraft', url: '/images/missions/moon/surveyor_spacecraft.jpg' },
  { type: 'image', key: 'surveyor', url: '/images/missions/moon/surveyor.png' },

  { type: 'image', key: 'apollo11spacecraft', url: '/images/missions/moon/apollo11_spacecraft.webp' },
  { type: 'image', key: 'apollo11', url: '/images/missions/moon/apollo11.webp' },

  { type: 'image', key: 'lunokhod1spacecraft', url: '/images/missions/moon/lunokhod1_spacecraft.jpg' },
  { type: 'image', key: 'lunokhod1', url: '/images/missions/moon/lunokhod1.jpg' },

  { type: 'image', key: 'clementinespacecraft', url: '/images/missions/moon/clementine_spacecraft.webp' },
  { type: 'image', key: 'clementine', url: '/images/missions/moon/clementine.webp' },

  { type: 'image', key: 'lrospacecraft', url: '/images/missions/moon/lro_spacecraft.webp' },
  { type: 'image', key: 'lro', url: '/images/missions/moon/lro.webp' },

  { type: 'image', key: 'change4spacecraft', url: '/images/missions/moon/change4_spacecraft.jpg' },
  { type: 'image', key: 'change4', url: '/images/missions/moon/change4.jpg' },

  { type: 'image', key: 'change5spacecraft', url: '/images/missions/moon/change5_spacecraft.jpg' },
  { type: 'image', key: 'change5', url: '/images/missions/moon/change5.jpeg' },

  { type: 'image', key: 'artemis1spacecraft', url: '/images/missions/moon/artemis1_spacecraft.jpg' },
  { type: 'image', key: 'artemis1', url: '/images/missions/moon/artemis1.jpg' },

  { type: 'image', key: 'chandrayaan3spacecraft', url: '/images/missions/moon/chandrayaan3_spacecraft.png' },
  { type: 'image', key: 'chandrayaan3', url: '/images/missions/moon/chandrayaan3.jpg' },

  { type: 'image', key: 'artemis2spacecraft', url: '/images/missions/moon/artemis2_spacecraft.jpg' },
  { type: 'image', key: 'artemis2', url: '/images/missions/moon/artemis2.jpg' },

  // Pluto
  { type: 'image', key: 'newhorizonsspacecraft', url: '/images/missions/pluto/newhorizons_spacecraft.webp' },
  { type: 'image', key: 'newhorizons_pluto', url: '/images/missions/pluto/newhorizons_pluto.jpg' },  
];

export const backgroundAssets =[
  //Milkyway
  { type: 'image', key: 'milkyway', url: '/images/milkyway_2k.webp' },
];

export const timelineAssets =[
  { type: 'image', key: 'precambrian', url: '/images/timeline/precambrian.png' },
  { type: 'image', key: 'paleozoic', url: '/images/timeline/paleozoic.png' },
  { type: 'image', key: 'mesozoic', url: '/images/timeline/mesozoic.png' },
  { type: 'image', key: 'cenozoic', url: '/images/timeline/cenozoic.png' },
];

export default function PlanetPreloader({ onComplete, onProgress, skipAnimation }) {
  const hasPreloaded = useRef(false);

  useEffect(() => {
    if (hasPreloaded.current) return;
    hasPreloaded.current = true;

    const assetsToLoad = [...planetAssets, ...earthAssets, ...missionAssets, ...timelineAssets];
    if (!skipAnimation) {
      assetsToLoad.push(...backgroundAssets);
    }

    let totalAssets = assetsToLoad.length;
    let loadedCount = 0;

    const handleProgress = () => {
      loadedCount++;
      const progress = Math.round((loadedCount / totalAssets) * 100);
      if (typeof onProgress === 'function') onProgress(progress);
    };

    preloadAssets(assetsToLoad, handleProgress)
      .then((loadedAssets) => {
        const normalizedAssets = {};
        for (const [key, value] of Object.entries(loadedAssets)) {
          normalizedAssets[key.toLowerCase()] = value;
        }
        if (typeof onComplete === 'function') onComplete(normalizedAssets);
      })
      .catch((err) => {
        console.error('Error preloading assets:', err);
      });

  }, [onComplete, onProgress, skipAnimation]);

  return null;
}